import MultipleListsContainer from './MultipleListsContainer';

export default MultipleListsContainer;
